import React from 'react'
import Form from "./component/AddForm"

const index = () => {
  return (
    <div>
      <Form/>
    </div>
  )
}

export default index
